import { render, staticRenderFns } from "./home.vue?vue&type=template&id=34f8b0e0"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f8b0e0')) {
      api.createRecord('34f8b0e0', component.options)
    } else {
      api.reload('34f8b0e0', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=34f8b0e0", function () {
      api.rerender('34f8b0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/basic/home.vue"
export default component.exports